export const DELETE_TITLE = 'Excluir Autônomo';

export const DELETE_MESSAGE = `
  Você está prestes a excluir o registro de autônomo.
  Uma vez feita esta ação não poderá ser desfeita.
  Você tem certeza de que deseja excluir este registro?
  <br><br>
  <strong>
    Ao excluir o cadastro, os pagamentos deste (a) autônomo (a) também serão excluídos do módulo folha.
  </strong>`;
